const customStylesDark = {
   overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(7,24,47, 0.65)',
   },
   content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      padding: '3rem',
      border: '#feb703 1px solid',
      backgroundColor: 'rgb(7, 24, 47)',
   },
}

export default customStylesDark